import { FC } from 'react';
import { Navigate, RouteProps } from 'react-router-dom';

import { FeatureFlagDisplay } from '@app/components';
import { FeatureFlagToMatch, Route } from '@app/constants';

type ConditionalRouteProps = {
  flagToMatch: FeatureFlagToMatch;
  shouldRenderOnFalse?: boolean;
};

export const ConditionalRoute: FC<RouteProps & ConditionalRouteProps> = ({
  flagToMatch,
  shouldRenderOnFalse = false,
  children,
}) => {
  const navigateToNotFound = () => <Navigate replace to={Route.notFound} />;
  const renderChildren = () => children;

  return (
    <FeatureFlagDisplay
      flagToMatch={flagToMatch}
      renderOn={shouldRenderOnFalse ? navigateToNotFound : renderChildren}
      renderOff={shouldRenderOnFalse ? renderChildren : navigateToNotFound}
    />
  );
};
